import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";
import useTranslation from "utils/hooks/useTranslation";

type DeletePopupProps = {
  isOpen: boolean;
  closePopup: () => void;
  onDelete: () => void | Promise<void>;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
};

export const DeletePopup: React.FC<DeletePopupProps> = ({
  isOpen,
  closePopup,
  onDelete,
  title,
  message,
  confirmText,
  cancelText,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <Popup 
      // title={title || t("Delete")} 
      onClose={closePopup} 
      fixSize="small" 
      portal
      noHorizontalLine
    >
      <group
        data-direction="column"
        data-gap="30"
        data-space="20"
        data-height="autofit"
        data-length="450"
      >
        <group data-gap="10">
          <group data-direction="column" data-gap="5" data-length="autofit">
            <text data-weight="600" data-text-size="larger" data-text-align="center" data-wrap="wrap" data-color="main">Delete Row</text>
            <text data-text-align="center" data-wrap="wrap" data-text-size="13" data-wrap-line="">
              <text data-wrap="wrap" data-text-size="medium">
                {message || t("Are you sure you want to delete?")}
              </text>
            </text>
          </group>
        </group>
        
        <group data-justify="center" data-gap="10">
          <Button
            type="button"
            onClick={() => {
              void onDelete();
            }}
            disabled={isLoading}
            className="large fit"
          >
            {confirmText || t("Yes")}
          </Button>
          <Button
            type="button"
            primary
            onClick={closePopup}
            disabled={isLoading}
            className="large fit primary"
          >
            {cancelText || t("No")}
          </Button>
        </group>
      </group>
    </Popup>
  );
};

export default DeletePopup;
